<template lang="pug">
.page-wrapper(:class="pageClass", v-if="user")
	notifications(group="default")
	#sidebar
		.logo
			img(alt="logo", :src="logoPath")
		SideMenu
	.wrap
		header
			a.nav-btn(href="javascript:void(0);", @click="toggleSidebar")
				i.la.la-bars
			.user-info
				router-link(:to="{ name: 'profile' }")
					span.user-name {{ user.name }}
				template(v-if="user.logged_as")
					span as
					PartnerSwitcher(v-if="canSwitchPartner")
					span.user-logged-as(v-else) {{ user.logged_as }}
				ThemeToggle
				a.btn-logout(href="javascript:void(0);", v-tooltip="'Logout'", @click="logout()")
					i.la.la-sign-out
		#content
			router-view(:key="$route.fullPath")
</template>

<script>
import { useAuthStore } from "@/stores/auth";
import PartnerSwitcher from "./PartnerSwitcher.vue";
import SideMenu from "./SideMenu.vue";
import ThemeToggle from "./ThemeToggle.vue";

const logos = import.meta.glob("../assets/*-logo*.png", { eager: true, import: "default" });

export default {
	name: "Layout",
	components: { SideMenu, ThemeToggle, PartnerSwitcher },
	data() {
		return {
			envName: import.meta.env.VUE_APP_ENV_NAME || "ovalio-media",
		};
	},
	computed: {
		authStore() {
			return useAuthStore();
		},
		user() {
			return this.authStore.user;
		},
		canSwitchPartner() {
			const u = this.user;
			return u?.type === "admin" && !!(u.advertiser_id || u.publisher_id);
		},
		pageClass() {
			return this.authStore.toggledSidebar ? "sidebar-toggled" : "sidebar-default";
		},
		logoPath() {
			const whiteThemes = ["thing-or-two", "eksmedia"];
			const suffix = whiteThemes.includes(this.envName) ? "-white" : "";
			const key = `../assets/${this.envName}-logo${suffix}.png`;
			return logos[key] || logos["../assets/ovalio-media-logo.png"];
		},
	},
	methods: {
		toggleSidebar() {
			this.authStore.toggleSidebar();
		},
		logout() {
			this.authStore.setUser(null);
			this.$router.push({ name: "login" });
		},
	},
};
</script>
